import { ReactComponent as ChatSmileyFilledSvg } from '../../assets/svg/chat-smiley-filled.svg';
import { ReactComponent as AnnouncementMegaphoneSvg } from '../../assets/svg/announcement-megaphone.svg';
import { ReactComponent as ChevronRightSvg } from '../../assets/svg/chevron-right.svg';
import { formatDate, FORMAT } from '../../lib/utils';

const TYPE = {
  SYSTEM: 'SYSTEM',
  NORMAL: 'NORMAL',
  PRIVATE: 'PRIVATE',
  WARNING: 'WARNING',
  URGENT: 'URGENT',
};

const NotificationIcon = ({ type }) => {
  if (type === TYPE.SYSTEM) {
    return <AnnouncementMegaphoneSvg className='size-5' />;
  }
  if (type === TYPE.NORMAL) {
    return <ChatSmileyFilledSvg className='size-5' />;
  }
  if (type === TYPE.PRIVATE) {
  }
  if (type === TYPE.WARNING) {
  }
  if (type === TYPE.URGENT) {
  }

  return null;
};

const NotificationItem = ({ item, handleClickNotification }) => {
  return (
    <div
      className='border rounded-xl px-2 py-1'
      onClick={
        handleClickNotification &&
        handleClickNotification({
          id: item.id,
          location: item.location,
          isRead: !!item.readAt,
        })
      }
    >
      <div className='flex gap-4'>
        <div className='pt-1'>
          <NotificationIcon type={item.type} />
        </div>
        <div className='flex justify-between items-center gap-4 flex-1'>
          <div className={`flex-1 ${item.readAt ? 'opacity-40' : 'font-bold'}`}>
            <div className='mb-1 line-clamp-2'>{item.content}</div>
            <div className='flex justify-between items-center text-xs opacity-80'>
              <div>{item.title}</div>
              <div>
                {formatDate(new Date(item.createdAt))}{' '}
                {formatDate(new Date(item.createdAt), FORMAT.HOURMIN)}
              </div>
            </div>
          </div>
          {item.location && (
            <div>
              <ChevronRightSvg className='size-4' />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
